import { payloadCmsApiBaseUrl } from '@/libs/fetcher/presets'
import type { PayloadMediaField } from '@/services/cms/homePageV2'

const payloadMediaFileBaseUrl = payloadCmsApiBaseUrl.replace(/\/v\d+$/, '') + '/media/file/'

export const getIconProperty = (
  data: string | PayloadMediaField | null | undefined,
  property: keyof PayloadMediaField,
): string => {
  if (data && typeof data === 'object' && data[property]) {
    return data[property] as string
  }
  return ''
}

export const getPayloadAssetURL = (
  media: string | PayloadMediaField | null | undefined,
): string => {
  if (!media || typeof media !== 'object') {
    return ''
  }
  if (media.filePath) {
    return media.filePath
  }
  if (media.filename) {
    return encodeURI(`${payloadMediaFileBaseUrl}${media.filename}`)
  }
  if (media.url) {
    return media.url
  }
  return ''
}
